import NavLinks from "./NavLinks";
import { Button } from "../ui/button";
import { LeadFormModal } from "../modals/LeadFormModal";
import { MessageCircle, Facebook, Instagram, Linkedin } from "lucide-react";
import { useState } from "react";

interface DesktopNavigationProps {
  scrollToSection: (id: string) => void;
  isScrolled?: boolean;
}

const DesktopNavigation = ({ scrollToSection, isScrolled = false }: DesktopNavigationProps) => {
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const scrolledStyles = isScrolled ? "text-muted-foreground" : "";

  const openContact = () => setContactModalOpen(true);
  const closeContact = () => setContactModalOpen(false);

  return (
    <>

      {/* Desktop Menu */}
      <div className={`hidden lg:flex items-center space-x-8 transition-colors duration-300 ${scrolledStyles}`}>
        <NavLinks scrollToSection={scrollToSection} />
      </div>

      {/* Social Icons and Contact Button */}
      <div className={`hidden lg:flex items-center gap-4 transition-colors duration-300 ${scrolledStyles}`}>
        {/* Social Icons */}
        <div className="flex items-center space-x-2">
          <a 
            href="https://www.facebook.com/profile.php?id=61575010856485" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Seguir a Nexus HR en Facebook"
            className="inline-flex items-center justify-center p-2 min-h-11 min-w-11 text-muted-foreground hover:text-primary transition-colors rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <Facebook size={20} aria-hidden="true" />
          </a>
          <a 
            href="https://www.instagram.com/nexushr.cr/" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Seguir a Nexus HR en Instagram"
            className="inline-flex items-center justify-center p-2 min-h-11 min-w-11 text-muted-foreground hover:text-primary transition-colors rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <Instagram size={20} aria-hidden="true" />
          </a>
          <a 
            href="https://www.linkedin.com/company/nexus-hr-costa-rica/" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Seguir a Nexus HR en LinkedIn"
            className="inline-flex items-center justify-center p-2 min-h-11 min-w-11 text-muted-foreground hover:text-primary transition-colors rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <Linkedin size={20} aria-hidden="true" />
          </a>
        </div>

        {/* Contact Button */}
        <Button
          onClick={openContact}
          className={`font-araboto font-medium text-sm px-5 py-2 rounded-full flex items-center gap-2 transition-all duration-300 ${
            isScrolled
              ? "bg-gray-700 hover:bg-white text-white hover:text-gray-700 border border-gray-700 hover:border-gray-700"
              : "bg-primary hover:bg-white text-primary-foreground hover:text-primary border border-primary hover:border-primary"
          }`}
        >
          <MessageCircle className="h-4 w-4" aria-hidden="true" />
          Contacto
        </Button>
      </div>

      <LeadFormModal
        isOpen={contactModalOpen}
        onClose={closeContact}
        route="/contacto"
      />
    </>
  );
};

export default DesktopNavigation;

